import React, { Component } from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';
import LogoDark from './Logo-Dark@2x.png'

import firebase from './firebase';
import SignupButton from './SignupButton';
import MediaQuery from 'react-responsive';

class HomeGalleryHeader extends Component {
  constructor(props) {
    super(props)

    this.state = {
      userDisplayName: '',
      isSignedIn: false
    }

    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        this.setState({
          userDisplayName: user.displayName,
          isSignedIn: true
        });
      } else {
        this.setState({
          userDisplayName: '',
          isSignedIn: false
        });
      }
    }.bind(this), function(error) {
      console.log(error);
    });
  }

  render() {
    return (

     <MediaQuery minDeviceWidth={400}>
       {(matches) => (
         <div style={{backgroundColor: this.props.muiTheme.palette.primary2Color,
                          //maxWidth: '1404px',
                          overflow: 'auto',
                          position: 'relative',
                          clear: 'none',
                          textAlign: 'center',
                          height: '70px',
                          margin: 'auto'}}>

             <div style={ matches ?
                 { position: 'absolute',
                           top: '0',
                           left: '0',
                           right: '0',
                           bottom: '0'}
                : {clear: 'none', display: 'inline', textAlign: 'left'}}>
               <a href="/" style={{ textDecoration: 'none',
                                    fontSize: '24px',
                                    height: '70px',
                                    color: this.props.muiTheme.palette.alternateTextColor }}>
                 <img alt="logo" style={{width: '165px', height: '50px', margin: '10px 10px 10px 10px'}} src={LogoDark} />
               </a>

             </div>

             <div style={{ display: 'inline-block', height: '70px',
                                 float: 'right', marginRight: "16px"}}>


                <SignupButton style={{position: 'relative', top: '50%', transform: "translateY(-50%)"}}
                  artists={this.props.artists} secondary={true}>
                  {this.props.artists ? "Sell Art" : "Get Art" }</SignupButton>

             </div>
         </div>
       )}
     </MediaQuery>

    )
  }
}


export default muiThemeable()(HomeGalleryHeader);



// WEBPACK FOOTER //
// ./src/HomeGalleryHeader.js